module.exports = __webpack_public_path__ + "static/media/HomeMobile.1a71106e.png";